// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__3mqG1","header":"DefaultLayout_header__2r34z","nav":"DefaultLayout_nav__1uagf","content":"DefaultLayout_content__4PTPw"};